import React from "react";
import { Form, InputGroup, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FormikProps } from "formik";
import { FormValues } from "../types";

interface SimulationConfigSectionProps {
  formik: FormikProps<FormValues>;
}

export const SimulationConfigSection = ({
  formik,
}: SimulationConfigSectionProps) => (
  <>
    <div>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <span className="simulacao-form-header">Dados de simulação</span>
        <span style={{ color: "#7e7e82" }}>
          Altere as taxas para ajustar a simulação dos anos seguintes e dos
          gráficos de payback
        </span>
      </div>

      <hr />
    </div>

    <div className="formLine">
      <Form.Group
        controlId="taxaAtratividade"
        style={{
          width: "100%",
          maxWidth: "375px",
          height: "80px",
        }}
      >
        <Form.Label
          className="simulacao-form-title"
          style={{ display: "flex", flexDirection: "row", gap: "8px" }}
        >
          Taxa de atratividade
          <OverlayTrigger
            overlay={
              <Tooltip id="tooltip-disabled">
                Parâmetro fundamental no cálculo do VPL (Valor Presente
                Líquido), com o intuito de atualizar os fluxos de caixa futuros
                para o valor presente. Utilize 0% para ter o cálculo do payback
                simples.
              </Tooltip>
            }
          >
            <div
              style={{
                width: "16px",
                height: "16px",
                borderRadius: "100%",
                backgroundColor: "#0072ce",
                display: "flex",
                color: "white",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "12px",
              }}
            >
              ?
            </div>
          </OverlayTrigger>
        </Form.Label>
        <InputGroup className="mb-3">
          <Form.Control
            name="taxaAtratividade"
            placeholder="Porcentagem"
            onBlur={formik.handleBlur}
            value={formik.values.taxaAtratividade}
            onChange={formik.handleChange}
            isInvalid={
              !!formik.touched.taxaAtratividade &&
              !!formik.errors.taxaAtratividade
            }
            min={0}
            max={100}
          />
          <InputGroup.Text>%</InputGroup.Text>
          <Form.Control.Feedback type="invalid">
            {formik.errors.taxaAtratividade}
          </Form.Control.Feedback>
        </InputGroup>
      </Form.Group>

      <Form.Group
        controlId="reajusteDistribuidora"
        style={{
          width: "100%",
          maxWidth: "375px",
          height: "80px",
        }}
      >
        <Form.Label className="simulacao-form-title">
          Taxa de reajuste da distribuidora <span>*</span>
        </Form.Label>
        <InputGroup className="mb-3">
          <Form.Control
            name="reajusteDistribuidora"
            placeholder="Porcentagem"
            onBlur={formik.handleBlur}
            value={formik.values.reajusteDistribuidora}
            onChange={formik.handleChange}
            isInvalid={
              !!formik.touched.reajusteDistribuidora &&
              !!formik.errors.reajusteDistribuidora
            }
            min={0}
            max={100}
          />
          <InputGroup.Text>%</InputGroup.Text>
          <Form.Control.Feedback type="invalid">
            {formik.errors.reajusteDistribuidora}
          </Form.Control.Feedback>
        </InputGroup>
      </Form.Group>

      <Form.Group
        controlId="reajusteEnergia"
        style={{
          width: "100%",
          maxWidth: "375px",
          height: "80px",
        }}
      >
        <Form.Label className="simulacao-form-title">
          Taxa de reajuste do preço de energia <span>*</span>
        </Form.Label>
        <InputGroup className="mb-3">
          <Form.Control
            name="reajusteEnergia"
            placeholder="Porcentagem"
            onBlur={formik.handleBlur}
            value={formik.values.reajusteEnergia}
            onChange={formik.handleChange}
            isInvalid={
              !!formik.touched.reajusteEnergia &&
              !!formik.errors.reajusteEnergia
            }
            min={0}
            max={100}
          />
          <InputGroup.Text>%</InputGroup.Text>
          <Form.Control.Feedback type="invalid">
            {formik.errors.reajusteEnergia}
          </Form.Control.Feedback>
        </InputGroup>
      </Form.Group>
    </div>
  </>
);
